import { gql, TypedDocumentNode } from "@apollo/client";

import { ConfigElement, ConfigInput } from "types/generated";

export const CONFIG_ELEMENT_FRAGMENT = gql`
  fragment configElement on ConfigElement {
    createdAt
    id
    description
    runtime
    type
    value
    writeOnly
    category
  }
`;

type AddEnvironmentConfigData = {
  stackConfigAdd: Pick<ConfigElement, "id" | "type">;
};

type AddEnvironmentConfigVariables = {
  stackId: string;
  input: ConfigInput;
};

export const ADD_ENVIRONMENT_CONFIG: TypedDocumentNode<
  AddEnvironmentConfigData,
  AddEnvironmentConfigVariables
> = gql`
  mutation AddEnvironmentConfig($stackId: ID!, $input: ConfigInput!) {
    stackConfigAdd(stack: $stackId, config: $input) {
      id
      type
    }
  }
`;

type UpdateEnvironmentConfigData = {
  stackConfigAdd: Pick<ConfigElement, "id" | "type">;
};

type UpdateEnvironmentConfigVariables = {
  stackId: string;
  input: ConfigInput;
};

export const UPDATE_ENVIRONMENT_CONFIG: TypedDocumentNode<
  UpdateEnvironmentConfigData,
  UpdateEnvironmentConfigVariables
> = gql`
  mutation UpdateEnvironmentConfig($stackId: ID!, $input: ConfigInput!) {
    stackConfigAdd(stack: $stackId, config: $input) {
      id
      type
    }
  }
`;

type DeleteEnvironmentConfigData = {
  stackConfigDelete: Pick<ConfigElement, "id" | "type"> | null;
};

type DeleteEnvironmentConfigVariables = {
  stackId: string;
  configId: string;
};

export const DELETE_ENVIRONMENT_CONFIG: TypedDocumentNode<
  DeleteEnvironmentConfigData,
  DeleteEnvironmentConfigVariables
> = gql`
  mutation DeleteEnvironmentConfig($stackId: ID!, $configId: ID!) {
    stackConfigDelete(stack: $stackId, id: $configId) {
      id
      type
    }
  }
`;
